"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cartesian_rectangle_1 = require("@rocketfarm/cartesian-rectangle");
// TODO remove
var PalletStacking = /** @class */ (function () {
    function PalletStacking() {
        this.lengthCount = 0;
        this.widthCount = 0;
        this.itemsCount = 0;
        this.pattern = new Array();
    }
    PalletStacking.prototype.rowsCount = function () {
        return this.lengthCount + this.widthCount;
    };
    return PalletStacking;
}());
// TODO remove
var Pattern = /** @class */ (function () {
    function Pattern(width, length, x, y, rotation, rotations) {
        if (rotation === void 0) { rotation = 0; }
        this.r = [0];
        this.w = width;
        this.l = length;
        this.x = x;
        this.y = y;
        this.r = rotations ? rotations : [rotation];
    }
    return Pattern;
}());
function fromPatternsToRotatedRectangleLocations(patterns) {
    return patterns.map(function (p) {
        var rotation = p.r[0];
        var rotate = Math.abs(rotation / 270) === 1 || Math.abs(rotation / 90) === 1;
        var _a = rotate ? [p.l, p.w] : [p.w, p.l], rectangleWidth = _a[0], rectangleLength = _a[1];
        var x = rotate ? p.x - p.l / 2 : p.x - p.w / 2;
        var y = rotate ? p.y - p.w / 2 : p.y - p.l / 2;
        return new cartesian_rectangle_1.RectangleLocation(rotate ? rectangleLength : rectangleWidth, rotate ? rectangleWidth : rectangleLength, x, y, rotate);
    });
}
exports.fromPatternsToRotatedRectangleLocations = fromPatternsToRotatedRectangleLocations;
// TODO remove usage of Pattern and PalletStacking
function basicRows(frameWidth, frameLength, boxWidth, boxLength, padding) {
    if (padding === void 0) { padding = 0; }
    var originalBoxWidth = boxWidth;
    var originalBoxLength = boxLength;
    // Add padding to box dimensions
    if (padding > 0) {
        boxWidth += padding * 2;
        boxLength += padding * 2;
    }
    var boxWidthsPerPalletWidth = Math.floor((frameWidth + padding * 2) / boxWidth);
    var boxLengthsPerPalletWidth = Math.floor((frameWidth + padding * 2) / boxLength);
    //
    // Find the best combination of "vertical" and "horizontal" rows of boxes
    //
    var shortestSide = boxWidth <= boxLength ? boxWidth : boxLength;
    var pallet = new PalletStacking();
    for (var boxWidths = 0; boxWidths * shortestSide <= (frameLength + 2 * padding); boxWidths++) {
        // Calculate number of boxes that can fit the remaining pallet length with 'boxWidths' number of boxes rotated 90 degrees
        var boxLengths = Math.floor((frameLength - boxWidths * boxWidth + 2 * padding) / boxLength);
        var count = boxWidths * boxLengthsPerPalletWidth + boxLengths * boxWidthsPerPalletWidth;
        if (pallet.itemsCount < count && boxLengths >= 0) {
            pallet.itemsCount = count;
            pallet.lengthCount = boxLengths;
            pallet.widthCount = boxWidths;
        }
    }
    //
    // Calculate placement for boxes
    //
    var totalProductLength = pallet.lengthCount * boxLength + pallet.widthCount * boxWidth;
    var startOffsetY = (frameLength - totalProductLength) / 2;
    var totalProductWidthOnPart1 = boxWidthsPerPalletWidth * boxWidth;
    var totalProductWidthOnPart2 = boxLengthsPerPalletWidth * boxLength;
    var rowCounter = 0;
    for (var i = 0; i < pallet.rowsCount(); i++) {
        if (i < pallet.lengthCount) {
            for (var u = 0; u < boxWidthsPerPalletWidth; u++) {
                var x = (frameWidth + totalProductWidthOnPart1) / 2 - boxWidth / 2 - boxWidth * u;
                var y = (frameLength - totalProductLength) / 2 + boxLength / 2 + boxLength * i;
                pallet.pattern.push(new Pattern(originalBoxWidth, originalBoxLength, x, y, 0));
            }
        }
        else {
            for (var u = 0; u < boxLengthsPerPalletWidth; u++) {
                var lengthOffset = startOffsetY + pallet.lengthCount * boxLength;
                var x = (frameWidth + totalProductWidthOnPart2) / 2 - boxLength / 2 - boxLength * u;
                var y = lengthOffset + boxWidth / 2 + boxWidth * rowCounter;
                pallet.pattern.push(new Pattern(originalBoxWidth, originalBoxLength, x, y, 90));
            }
            rowCounter++;
        }
    }
    return fromPatternsToRotatedRectangleLocations(pallet.pattern);
}
exports.basicRows = basicRows;
function basicColumns(frameWidth, frameLength, boxWidth, boxLength, padding) {
    if (padding === void 0) { padding = 0; }
    var result = basicRows(frameWidth, frameLength, boxWidth, boxLength, padding);
    return result.map(function (r) {
        return new cartesian_rectangle_1.RectangleLocation(r.getRectangleWidth(), r.getRectangleLength(), r.getYMin(), frameWidth - r.getXMin() - (r.isRotated() ? r.getWidth() : r.getRectangleWidth()), !r.isRotated());
    });
}
exports.basicColumns = basicColumns;
